//outfitPrompt.ts — one sentence describing every garment in the outfit

import { type Garment, garmentPrompt } from './garment'
import { outfitClause } from './garmentSlot'

//Decart's docs put a single garment at 20-30 words and their outfit example at 25-40, so a
//combined description stays one sentence with a clause per slot.
export function outfitPrompt(garments: readonly Garment[]): string {
	if (garments.length === 0) return ''
	if (garments.length === 1) return garmentPrompt(garments[0]!)
	const clauses = garments.map((g) => outfitClause(g.slot, g.detail))
	return `Substitute the current outfit with ${joinClauses(clauses)}`
}

function joinClauses(clauses: readonly string[]): string {
	if (clauses.length <= 1) return clauses[0] ?? ''
	return `${clauses.slice(0, -1).join(', ')} and ${clauses[clauses.length - 1]}`
}
